<template>
  <div class="home">
    <div class="banner">
      <div class="contentMain">
        <div class="title"> 微信小程序 </div>
        <div class="title"> 视频播放解决方案服务商 </div>
        <div class="titleTip"> 快速发布小程序，解决无资质审核问题 </div>
      </div>
      <el-image :src="logo"></el-image>
    </div>

    <div class="itemMain">
      <div class="main">
        <div class="mainTxt">
          <div class="txtTitle"> 视频播放插件产品介绍 </div>
          <div class="txtBox">
            <div class="itemTxt"> 淏睿视频插件，是基于微信平台搭建的视频播放器 </div>
            <div class="itemTxt"> 主要服务于无视频播放资质，想实现小程序视频播放功能的客户 </div>
            <div class="itemTxt"> 实现小程序视频资质安全过审，快速发布 </div>
          </div>
        </div>
        <div class="mainImg">
          <el-image :src="require('./images/videoImg.png')"></el-image>       
        </div>
      </div>
    </div>

    <div class="itemMain addMain">
      <div class="main addPadding">
        <div class="mainTxt">
          <div class="txtTitle"> 我们的优势 </div>
          <div class="txtBox">
            <div class="itemTxt"> ·性价比高，相对同行价格优惠，性能稳定 </div>
            <div class="itemTxt"> ·快速配置，3分钟接入，只需配置小程序appid和域名即可 </div>
            <div class="itemTxt"> ·视频审核，视频异步审核，最快2分钟上线 </div>
            <div class="itemTxt"> ·播放流畅，播放稳定流畅，无广告无水印 </div>
            <div class="itemTxt"> ·插件特点，完美继承小程序原生{{text}}所有属性、方法和特性 </div>
          </div>
        </div>
        <div class="mainImg">
          <el-image fit="contain" :src="require('./images/advantageImg.png')"></el-image>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      logo: require("./images/banner.png"),
      text: '<video>'
    };
  },

  mounted(){
    // window.addEventListener('scroll', this.handleScroll);

  },

  methods: {
    // handleScroll(){
    //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    // }
  },
};
</script>

<style scoped lang='less'>
.home {
  width: 100%;

  .banner {
    width: 100%;
    height: 100%;
    display: contents;
    position: relative;
    // height: 656px;

    .el-image {
      display: contents;
    }

    .contentMain {
      position: absolute;
      top: 260px;
      left: 130px;
      z-index: 100;
      color: #3F66FF;

      .title {
        font-size: 100px;
      }

      .titleTip {
        font-size: 50px;
        margin-top: 30px;
      }
    }
  }

  .itemMain{
    background: #fff;

    .main{
      padding: 170px 0;
      margin: 0 150px;
      display: flex;
      align-items: center;

      .mainTxt{

        .txtTitle{
          font-size: 45px;
          color: #333;
          margin-bottom: 40px;
        }
        .txtBox{

          .itemTxt{
            color: #4f4f4f;
            font-size: 36px;
            margin-bottom: 20px;
          }
        }
      }
      

      .mainImg{
        // width: 430px;
        // height: 430px;
        margin-left: auto;
      }
    }

    .addPadding{
      padding: 90px 0;
    }
  }

  .addMain{
    background: #EEF3FF;
  }
}

.addMain{
  background: #EEF3FF;
}

/* 复合动画：移动 + 旋转 + 缩放 */
@keyframes move-rotate-scale {
  0% {
    transform: translateX(-80px) rotateY(0deg) scale(0.8);
  }
  50% {
    transform: translateX(80px) rotateY(180deg) scale(1.2);
  }
  100% {
    transform: translateX(-80px) rotateY(360deg) scale(0.8);
  }
}

.horizontal-rotate {
  animation: move-rotate-scale 8s ease-in-out infinite;
  transform-style: preserve-3d;
}

</style>